import React from "react";

const ContactPerson = ({ data }) => {
  return (
    <div className="wow zoomIn">
      <p dangerouslySetInnerHTML={{ __html: data }}></p>
    </div>
  );
};

export default ContactPerson;
